import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';

@Injectable()
export class PrivacypolicyService {

  constructor(public http: Http) {
    console.log("Privacy Policy service connected");
  }

  getPrivacyPolicyDetails(customerId) {
    return this.http.get(environment.host + '/api/account/GetCustomerPrivacyPolicy?customerId=' + customerId)
      .map(res => res.json());
  }

  deactivatedCustomerEmail(email) {
    return this.http.get(environment.host + '/api/account/DeactiveCustomerEmailExist?emailAddress=' + email)
      .map(res => res.json());
  }

  validateCustomerPrivacyPolicy(email) {
    return this.http.get(environment.host + '/api/account/IsCustomerExistWithPrivacyPolicy?emailAddress=' + email)
      .map(res => res.json());
  }
  // savePrivacyPolicyDetails(customerPrivacyPolicy){
  //   return this.http.post(environment.host +'/api/account/AddCustomerPrivacyPolicy', customerPrivacyPolicy)
  //   .map(res => res.json());
  // }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/authentication/services/privacypolicy.service.ts